export const CLIENT_ROUTES: Record<string, string> = {
  ACCEPT_TERMS: '/callback/accept-terms',
  ACCEPT_USE_POLICY: '/callback/accept-use-policy',
  ACCOUNT_DETAILS: '/account-details',
  AUTH_CALLBACK: '/callback',
  LOGOUT: '/logout',
  MAGIC_LINK: '/magicLink',
  NOTIFICATIONS_PREFERENCES: '/notifications-preferences',
  PRIVACY: '/privacy-policy',
  PROFILE_ENRICH: '/callback/profile-enrichment',
  SAVED_VIEWS: '/saved-views',
  REQUEST_ACCESS: '/request-access',
  TERMS: '/terms-and-conditions',
  USE_POLICY: '/acceptable-use-policy',
};

export const USER_VOICE = {
  URL: 'https://nielseniq.uservoice.com/forums/',
  INDUSTRY_FORUM: 957416,
  RETAIL_FORUM: 955847,
};

export const HELP_RESOURCES_URLs = {
  HELP_CENTER_URL: 'https://helpcenter.gfk.com',
  ONBOARDING_VIDEOS_URL: 'https://helpcenter.gfk.com/onboarding-video-tutorials',
  LIVE_TRAINING_URL: 'https://attendee.gototraining.com/7h27n/catalog/5128565784237336320',
};

export const LAST_ROUTE = 'CLIENT_ROUTE';
export const NO_FILES_MESSAGE = 'There are no files yet. All uploaded files will appear here.';
